'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
export default class EnumField extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      this.props.onChange(value);
    };
  }
  getOptions() {
    return this.props.schema.enum.map(e => {
      return {
        text: e,
        value: e
      };
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UISelect, {
      options: this.getOptions(),
      defaultValue: '',
      value: this.props.formData,
      onChange: this.onChange,
      autoFocus: this.props.autoFocus,
      disabled: this.props.disabled,
      placeholder: this.props.placeholder,
      readOnly: this.props.readOnly,
      clearable: !this.props.required,
      menuWidth: "auto"
    });
  }
}
EnumField.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  schema: PropTypes.shape({
    enum: PropTypes.array.isRequired
  }).isRequired,
  formData: PropTypes.string
};